function getEntryFromArray(arr, entryId) {
  return arr.find((x) => x.sys.id == entryId).fields;
}

export { getEntryFromArray };
